import { SegmentedControl } from 'blaze-ui/SegmentedControl/SegmentedControl'
import { Document, Folder, Loader1, Palette, Upload, Users } from 'blaze-ui/icons'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { Menu } from 'components/Menu/Menu'
import { Item, Section as StatelySection } from '@react-stately/collections'
import { Key } from 'react'
import { IconButton as MobileButton } from 'blaze-ui/IconButton/IconButton'
import { Filter } from 'blaze-ui/icons/24'

export type FileType = 'all' | 'articles' | 'projects' | 'designs' | 'uploads' | 'shared'

interface Props {
  onSelect: (fileType: FileType) => void
  fileType: FileType
  exclude?: FileType[]
}

export const FileTypeFilter = ({ onSelect, fileType, exclude = [] }: Props) => {
  const designsFlag = useFlipperFlag('visual_studio')
  const { isMobile } = useResponsiveDesign()

  let items = [
    {
      name: 'all',
      startElement: <Loader1 />,
      icon: Loader1,
      text: 'All',
    },
    {
      name: 'projects',
      startElement: <Folder />,
      icon: Folder,
      text: 'Projects',
    },
    {
      name: 'articles',
      startElement: <Document />,
      icon: Document,
      text: 'Docs',
    },
  ]

  if (designsFlag) {
    items.push({
      name: 'designs',
      startElement: <Palette />,
      icon: Palette,
      text: 'Designs',
    })
  }

  items.push({
    name: 'shared',
    startElement: <Users />,
    icon: Users,
    text: 'Shared with me',
  })

  if (!isMobile) {
    items.push({
      name: 'uploads',
      startElement: <Upload />,
      icon: Upload,
      text: 'Uploads',
    })
  }

  // Filter out excluded items
  items = items.filter((item) => !exclude.includes(item.name as FileType))

  if (isMobile)
    return (
      <DropdownTrigger placement="bottom-start">
        <MobileButton icon={Filter} variant="editor" rounded />
        {(close) => (
          <Menu
            onAction={(key: Key) => {
              onSelect(key as FileType)
              close()
            }}
            aria-label="File type menu"
            selectionMode="single"
            selectedKeys={new Set([fileType])}
          >
            <StatelySection>
              {items.map((item) => (
                <Item key={item.name} textValue={item.text}>
                  {item.startElement} {item.text}
                </Item>
              ))}
            </StatelySection>
          </Menu>
        )}
      </DropdownTrigger>
    )

  return (
    <SegmentedControl activeItem={fileType} onItemClick={(type) => onSelect(type as FileType)}>
      {items.map((item) => (
        <Item key={item.name} textValue={item.text}>
          {item.startElement} {item.text}
        </Item>
      ))}
    </SegmentedControl>
  )
}
